module.exports = __webpack_public_path__ + "static/media/linked-in.4b475fb3.svg";